export const onlyNumbersRegex = /^\d+$/;

export function onlyNumbers(string) {
  if (!string) return true;

  return onlyNumbersRegex.test(string);
}
